import { render, staticRenderFns } from "./item-query.vue?vue&type=template&id=1abb97e6"
import script from "./item-query.vue?vue&type=script&lang=js"
export * from "./item-query.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports